<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>{{ service.name }}</h3>
        </div>
        <div class="flex flex-col">
          <vs-table :data="[1]">
            <template slot="thead">
              <th style="width: 200px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Nama Layanan</td>
                <td>:</td>
                <td>{{ service.name }}</td>
              </tr>
              <tr>
                <td>Kode Layanan</td>
                <td>:</td>
                <td>{{ service.service_code }}</td>
              </tr>
              <tr>
                <td>Status Layanan</td>
                <td>:</td>
                <td>{{ service.status == 1 ? "Aktif" : "Tidak Aktif" }}</td>
              </tr>
            </tbody>
          </vs-table>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h3>LIST LOKET {{ service.name }}</h3>
        </div>
        <div class="flex flex-col">
          <vs-table :data="counter">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Loket</vs-th>
              <vs-th>Deskripsi</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.counter_name">{{ tr.counter_name }}</vs-td>
                <vs-td :data="tr.counter_description">{{
                  tr.counter_description
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h3>LIST CLUSTER</h3>
        </div>
        <vs-alert title="Informasi" class="my-5">
          Berikut merupakan list cluster pada layanan antrian
          {{ service.name }}, anda dapat mengatur kapasitas antrian setiap
          cluster sesuai dengan <b>kebutuhan dan kesanggupan loket</b> dalam
          melayani antrian. Pada pukul <b> 17.00</b> setiap harinya, kapasitas antrian akan kembali di set default.
        </vs-alert>
        <hr />
        <br />
        <div class="flex flex-col">
          <vs-table :data="cluster">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Waktu</vs-th>
              <vs-th>Kapasitas Antrian</vs-th>
              <vs-th>Antrian Terdaftar</vs-th>
              <vs-th>Antrian Tersedia</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="item" :key="index++" v-for="(item, index) in data">
                <vs-td :data="index">{{ index }}</vs-td>
                <vs-td :data="item.start_time">
                  <span :class="item.time_status.color">{{ `${item.start_time} - ${item.end_time}` }}</span>
                </vs-td>
                <vs-td :data="item.capacity">{{ item.capacity }}</vs-td>
                <vs-td :data="item.booked_queue">
                  <div v-if="item.booked_queue > 0">{{ item.booked_queue }}</div>
                  <div v-else class="text-grey">Tidak Ada</div>
                </vs-td>
                <vs-td :data="item.capacity_rest">
                  <div v-if="item.capacity_rest > 0" class="">
                    {{ item.capacity_rest }}
                  </div>
                  <div v-else class="text-danger">Habis</div>
                </vs-td>
                <vs-td :data="item.cluster_status">
                  <vs-chip :color="item.cluster_status.color">{{item.cluster_status.label}}</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      type="border"
                      color="primary"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="openEditPopup(item)"
                      >Edit Kapasitas</vs-button
                    >
                  </div>
                </vs-td>
              </vs-tr>
          
            </template>
          </vs-table>
        </div>
      </vs-card>
      <vs-button
        @click="$router.push({ name: 'manajemen-cluster' })"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
        >Kembali</vs-button
      >
    </div>
    <PopupEditClusterCapacity
      :active.sync="popupEdit"
      :cluster="selectedCluster"
      @reloadData="reloadData"
    />
  </div>
</template>

<script>
import PopupEditClusterCapacity from "./components/PopupEditClusterCapacity.vue";

export default {
  components: {
    PopupEditClusterCapacity
  },
  data() {
    return {
      service: [],
      counter: [],
      cluster: [],
      popupEdit: false,
      selectedCluster: null
    };
  },
  mounted() {
    this.getService();
  },
  methods: {
    getService() {
      this.$http
        .get(`/app/secure/cluster/services/${this.$route.params.id}`)
        .then(r => {
          this.service = r.data.data.service;
          this.counter = r.data.data.counter;
          this.cluster = r.data.data.cluster;
          this.setOnUpdateQueue(r.data.data.service.id);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    openEditPopup(cluster) {
      this.selectedCluster = cluster;
      this.popupEdit = true;
    },
    reloadData() {
      this.getService();
    },
    setOnUpdateQueue(serviceId) {
      this.$echo
        .private(`User.Queue.${serviceId}`)
        .listen(".OnUpdateQueueEvent", () => {
          this.reloadData();
        });
    },
  }
};
</script>
>
